
import { defineComponent } from "vue";
export default defineComponent({
	name: "imdex-gradient-image",
	data() {
		return {
			gradient: [] as any,
			refreshKey: 0
		};
	},
	props: {
		rgbPoints: {
			type: Array,
			default: () => []
		},
		size: {
			type: Array,
			default: () => [25, 25]
		},
		active: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			const min = this.rgbPoints[0] as number;
			const max = this.rgbPoints[this.rgbPoints.length - 4] as number;
			this.gradient = [];
			for (let i = 0; i < this.rgbPoints.length; i += 4) {
				const [val, r, g, b] = [
					this.rgbPoints[i],
					this.rgbPoints[i + 1],
					this.rgbPoints[i + 2],
					this.rgbPoints[i + 3]
				] as any;
				const stop = {
					color: this.rgbToHex(
						Math.round(r * 255),
						Math.round(g * 255),
						Math.round(b * 255)
					),
					stop: (val - min) / (max - min)
				};
				this.gradient.push(stop);
				this.refreshKey++;
			}
		},
		hexToRgb(hex: string) {
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return {
				r: parseInt(result![1], 16),
				g: parseInt(result![2], 16),
				b: parseInt(result![3], 16)
			};
		},
		rgbToHex(r: number, g: number, b: number) {
			const componentToHex = (c: any) => {
				const hex = c.toString(16);
				return hex.length == 1 ? "0" + hex : hex;
			};
			return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
		}
	},
	watch: {
		rgbPoints: {
			deep: true,
			handler(v) {
				this.$nextTick(() => {
					this.init();
				});
			}
		}
	},
	computed: {
		gradientScheme(): any {
			this.refreshKey;
			const arr = [] as string[];

			for (let i = 0; i < this.gradient.length; i++) {
				const val = `${this.gradient[i].color} ${this.gradient[i].stop * 100 + "%"}`;
				arr.push(val);
			}

			return `linear-gradient(90deg, ${arr.join(",")})`;
		}
	}
});
